<template>
  <div class="live-dashboard vh-100 d-flex flex-column">
    <b-row
      align-content="center"
      match-height
    >
      <b-col
        cols="12"
        md="3"
      >
        <counter-card
          title-text="Satış Adet"
          sub-title-text="Yıllık"
          :value-data="dashboardData.counters.ytdSales | toNumber"
          color-class="success"
          prefix-text=""
          suffix-text="Adet"
          icon-name="ActivityIcon"
          tooltip-text="Veriyi Güncelle"
          data-type="counters"
          :refresh-data="refreshData"
          :is-loading="loadings.counters"
        />
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <counter-card
          title-text="Satış Adet"
          sub-title-text="Aylık"
          :value-data="dashboardData.counters.mtdSales | toNumber"
          color-class="info"
          prefix-text=""
          suffix-text="Adet"
          icon-name="CalendarIcon"
          tooltip-text="Veriyi Güncelle"
          data-type="counters"
          :refresh-data="refreshData"
          :is-loading="loadings.counters"
        />
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <counter-sale-value-date-avg
          :data-item="dashboardData.counters.saleValueDateAVG"
          :refresh-data="refreshData"
          :is-loading="loadings.counters"
        />
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <counter-interview-sale-rate
          :data-item="dashboardData.counters.interviewSaleRate2"
          :refresh-data="refreshData"
          :is-loading="loadings.counters"
        />
      </b-col>
    </b-row>
    <b-row
      align-content="center"
      match-height
    >
      <b-col
        cols="12"
        md="4"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Aylık Satış Trendi"
            card-sub-title="Yıllık"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="monthlySales"
          />
          <div
            v-if="loadings.monthlySales"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <area-charts
              v-if="dashboardData.monthlySales.series.length"
              :series-data="dashboardData.monthlySales.series"
              :categories-data="dashboardData.monthlySales.categories"
              chart-height="250"
            />
          </template>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Marka Bazlı Satış Adet"
            card-sub-title="Aylık"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="brandSales"
          />
          <div
            v-if="loadings.brandSales"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <pie-charts
              v-if="dashboardData.brandSales.series.length"
              :series-data="dashboardData.brandSales.series"
              :labels-data="dashboardData.brandSales.labels"
              :colors-data="dashboardData.brandSales.colors"
            />
          </template>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="5"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Marka Bazlı Karlılık % - ₺"
            card-sub-title="Aylık - Yıllık"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="brandProfitabilityTable"
          />
          <div
            v-if="loadings.brandProfitabilityTable"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <table-brand-profitability :data-list="dashboardData.brandProfitabilityTable" />
          </template>
          <!--          <card-header-brand-profitability-->
          <!--            card-title="Marka Bazlı Karlılık %"-->
          <!--            :card-sub-title="dashboardData.brandProfitability.is_ytd? dashboardData.brandProfitability.ytd.date_range : dashboardData.brandProfitability.mtd.date_range"-->
          <!--            tooltip-text="Veriyi Güncelle"-->
          <!--            :refresh-data="refreshData"-->
          <!--            data-type="brandProfitability"-->
          <!--          />-->
          <!--          <div-->
          <!--            v-if="loadings.brandProfitability"-->
          <!--            class="d-flex align-items-center justify-content-center h-100"-->
          <!--          >-->
          <!--            <pre-loading is-flat />-->
          <!--          </div>-->
          <!--          <template v-else>-->
          <!--            <template v-if="dashboardData.brandProfitability.is_ytd">-->

          <!--              <column-charts-->
          <!--                v-if="dashboardData.brandProfitability.ytd.series.length"-->
          <!--                :series-data="dashboardData.brandProfitability.ytd.series"-->
          <!--                :categories-data="dashboardData.brandProfitability.ytd.categories"-->
          <!--                :colors-data="dashboardData.brandProfitability.ytd.colors"-->
          <!--              />-->
          <!--            </template>-->
          <!--            <template v-else>-->
          <!--              <column-charts-->
          <!--                v-if="dashboardData.brandProfitability.mtd.series.length"-->
          <!--                :series-data="dashboardData.brandProfitability.mtd.series"-->
          <!--                :categories-data="dashboardData.brandProfitability.mtd.categories"-->
          <!--                :colors-data="dashboardData.brandProfitability.mtd.colors"-->
          <!--              />-->
          <!--            </template>-->
          <!--          </template>-->
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Stok Adetleri"
            card-sub-title="Marka Bazlı"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="brandStocks"
          />
          <div
            v-if="loadings.brandStocks"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <b-row class="h-100">
              <b-col
                cols="12"
                md="8"
                class="h-100"
              >
                <stacked-bar-charts
                  :series-data="dashboardData.brandStocks.series"
                  :categories-data="dashboardData.brandStocks.categories"
                  :colors-data="dashboardData.brandStocks.colors"
                />
              </b-col>
              <b-col>
                <table-stocks :data-list="dashboardData.brandStocks.tableData" />
              </b-col>
            </b-row>
          </template>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <b-card
          no-body
          class="card-fixed"
        >
          <card-custom-header
            card-title="Satış Performansı"
            card-sub-title="Marka Bazlı"
            tooltip-text="Veriyi Güncelle"
            :refresh-data="refreshData"
            data-type="salePerformance"
          />
          <div
            v-if="loadings.salePerformance"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <pre-loading is-flat />
          </div>
          <template v-else>
            <table-performance
              v-if="dashboardData.salePerformance.brands.length"
              :data-list="dashboardData.salePerformance.brands"
              :grand-totals="dashboardData.salePerformance.grandTotals"
            />
          </template>
        </b-card>
      </b-col>
    </b-row>
    <report-customizer
      :cache-info="cacheInfo"
      :refresh-data="refreshDashboard"
      :start-countdown="startCountdown"
    />
  </div>
</template>
<script>
import {
  BRow, BCol, BCard,
} from 'bootstrap-vue'
import PreLoading from '@/layouts/components/Loading.vue'
import CounterCard from '@/views/Dashboard/Live/Components/CounterCard.vue'
import AreaCharts from '@/views/Dashboard/Live/SalesDashboard/AreaCharts.vue'
import PieCharts from '@/views/Dashboard/Live/Charts/PieCharts.vue'
// import ColumnCharts from '@/views/Dashboard/Live/Charts/ColumnCharts.vue'
import StackedBarCharts from '@/views/Dashboard/Live/Charts/StackedBarCharts.vue'
import TablePerformance from '@/views/Dashboard/Live/SalesDashboard/TablePerformance.vue'
import CounterInterviewSaleRate from '@/views/Dashboard/Live/SalesDashboard/CounterInterviewSaleRate.vue'
import CounterSaleValueDateAvg from '@/views/Dashboard/Live/SalesDashboard/CounterSaleValueDateAvg.vue'
// import CardHeaderBrandProfitability from '@/views/Dashboard/Live/SalesDashboard/CardHeaderBrandProfitability.vue'
import CardCustomHeader from '@/views/Dashboard/Live/Components/CardCustomHeader.vue'
import ReportCustomizer from '@/views/Dashboard/Live/Components/ReportCustomizer.vue'
import TableBrandProfitability from '@/views/Dashboard/Live/SalesDashboard/TableBrandProfitability.vue'
import TableStocks from '@/views/Dashboard/Live/SalesDashboard/TableStocks.vue'

export default {
  name: 'SalesDashboard',
  components: {
    BRow,
    BCol,
    BCard,
    PieCharts,
    AreaCharts,
    // ColumnCharts,
    StackedBarCharts,
    TablePerformance,
    CounterInterviewSaleRate,
    CounterSaleValueDateAvg,
    // CardHeaderBrandProfitability,
    CounterCard,
    PreLoading,
    CardCustomHeader,
    TableBrandProfitability,
    TableStocks,
    ReportCustomizer,
  },
  data() {
    return {
      intervalId: null,
    }
  },
  computed: {
    loadings() {
      return this.$store.getters['liveSalesDashboard/loadings']
    },
    dashboardData() {
      return this.$store.getters['liveSalesDashboard/dashboardData']
    },
    cacheInfo() {
      return this.$store.getters['liveSalesDashboard/cacheInfo']
    },
    configData() {
      return this.$store.getters['liveDashboardConfig/configData']
    },
  },
  mounted() {
    this.startCountdown()
  },
  created() {
    this.getDashboard()
  },
  methods: {
    startCountdown() {
      if (this.configData.refreshTime !== false) {
        this.intervalId = setInterval(() => {
          this.refreshDashboard()
        }, this.configData.refreshTime)
      }
    },
    getDashboard() {
      this.getData('counters')
      this.getData('monthlySales')
      this.getData('brandSales')
      this.getData('brandProfitability')
      this.getData('brandProfitabilityTable')
      this.getData('brandStocks')
      this.getData('salePerformance')
    },
    refreshDashboard() {
      this.$store.commit('liveSalesDashboard/RESET_DASHBOARD_DATA')
      this.refreshData('counters')
      this.refreshData('monthlySales')
      this.refreshData('brandSales')
      this.refreshData('brandProfitability')
      this.refreshData('brandProfitabilityTable')
      this.refreshData('brandStocks')
      this.refreshData('salePerformance')
    },
    getData(type) {
      this.$store.dispatch('liveSalesDashboard/getData', { type })
    },
    refreshData(type) {
      this.$store.dispatch('liveSalesDashboard/refreshData', { type })
    },
  },
}
</script>
<style scoped>
.card-small .card-body{
  padding: 10px !important;
}
.card-fixed{
  overflow: hidden;
}
</style>
<style lang="scss">
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
